<template>
  <div class="SECTION p-t-6">
    <div v-if="isLoading"/>
    <div v-else>
      <div class="p-6 bg-gray20">
        <div class="h2 text-bold c-gray90 m-b-2">{{title}}
        </div>
        <div class="c-gray70 d-flex">
          <div class="TEXT-AREA p-r-2 p-r-4:d">
            <div class="p-b-4 PRE-LINE" >
              {{description}}
            </div>
          </div>
          <div>
            <button
                class="btn-lg btn BUTTON"
                @click="goToSalesforce()">
              {{cta}}
            </button>
          </div>
        </div>
      </div>
      <div v-if="hasError" class="d-flex fd-column">
        <div class="p-6 TEXT-ERROR">
          {{errorStatement}}
        </div>
        <img
            v-if="hasContentError"
            class="IMAGE"
            src="./assets/emptystate_screwdriver.svg"
        />
        <img
            v-else
            class="IMAGE"
            src="./assets/emptystate_wrench.svg"

        />
      </div>
      <div v-else>
        <div
            v-for="(section, index) in content.sections"
            :key="index">
          <testimonials-section
              @content-error="contentError()"
              :index="index"
              :section="section"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import TestimonialsSection from './components/TestimonialsSection';

export default {
  name: 'testimonials',
  components: {
    TestimonialsSection,
  },
  data () {
    return {
      content: {},
      isLoading: false,
      hasContentError: false,
    };
  },
  computed: {
    hasError () {
      this.updateHasContentError(this.content && Object.keys(this.content).length === 0);
      if (this.hasContentError) {
        return true;
      }
      return Object.prototype.hasOwnProperty.call(this.content, 'error');
    },
    title () {
      return this.hasError ? 'Why Pro Referral?' : this.content.title;
    },
    description () {
      return this.hasError ? 'Pro Referral is the trusted marketplace to connect loyal Pros with loyal \nHome Depot customers in their area.\n\nOur goal is to help local business owners and independent contractors grow their businesses by offering cost-free leads and an automated platform that helps them manage jobs and customers on the go' : this.content.description;
    },
    cta () {
      return this.hasError ? 'Onboard a Pro' : this.content.cta;
    },
    errorStatement () {
      return this.hasContentError ? 'Check back later to read testimonials from our happy Pro Referral pros and how the Help Desk makes a difference.' : 'Oops! We’re experiencing an issue. Check back later to read testimonials from our happy Pro Referral pros and how the Help Desk makes a difference.';
    },
  },
  watch: {
    hasError: {
      handler (newVal) {
        if (newVal) {
          if (!this.hasContentError) {
            this.$events.$emit(
              this.$events.TESTIMONIAL_ERROR,
              { storeId: this.$route.params.storeId }
            );
          }
        }
      },
      immediate: true,
    },
  },
  mounted () {
    this.getTestimonials();
  },
  methods: {
    updateHasContentError (isTrue) {
      this.hasContentError = isTrue;
    },
    contentError () {
      this.$events.$emit(
        this.$events.TESTIMONIAL_CONTENT_ERROR,
        { storeId: this.$route.params.storeId }
      );
      this.hasContentError = true;
    },
    async getTestimonials () {
      this.isLoading = true;
      await axios.get('/api/contentful/testemonials')
        .then(({ data }) => {
          this.content = data || {};
        });
      setTimeout(() => {
        this.isLoading = false;
      }, 1000);
    },
    goToSalesforce () {
      this.$events.$emit(this.$events.PRO_SIGNUP, {
        occupation: 'None Selected',
      });
      /* eslint-disable-next-line max-len */
      window.location.href = `${this.$runtimeConstants.SALESFORCE_BECOME_A_PRO}?source=store&STOREID=${this.$route.params.storeId}`;
    },
  },
};

</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools.scss";

.SECTION {
  max-width: $unit * 118;
}
.PRE-LINE {
  white-space: pre-line;
}
.TEXT-AREA{
  font-size: 18px;
  @include tablet{
    width: $unit * 88;
  }
}
.TEXT-ERROR{
  font-size: 18px;
  @include tablet{
    width: $unit * 90;
  }
}
.BUTTON{
  width: $unit * 27.5;
}
.IMAGE {
  align-self: start;
  padding-left: 23.5 * $unit;
  padding-bottom: 3 *$unit;
}

</style>
